import API from 'services/api';

type TCustomerId = {
  customerId: number;
};

export const getNewRoles = (payload: TCustomerId) =>
  API.post('/api/roles/new', payload).then(response => response?.data);
